module.exports = __webpack_public_path__ + "static/media/Global-Sourcing-Marketplace.3c39c489.png";